import { Box } from '@mui/material';
import { Button } from '../../../../shared/components/ui/Button';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import type { Visitor } from '../../../../shared/services/visitors/visitorService';

interface ActionButtonsProps {
  visitor: Visitor;
  onEdit: (visitor: Visitor) => void;
  onDelete: (visitor: Visitor) => void;
}

export function ActionButtons({ visitor, onEdit, onDelete }: ActionButtonsProps) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mb: 2 }}>
      <Button
        variant="outlined"
        color="primary"
        startIcon={<EditIcon />}
        sx={{ fontWeight: 700, fontSize: 16, borderRadius: 2, px: 3, py: 1, textTransform: 'none', bgcolor: '#F0F6FF', borderColor: '#B6D4FE', '&:hover': { bgcolor: '#E3EDFC', borderColor: '#B6D4FE' } }}
        onClick={() => onEdit(visitor)}
      >
        Editar Visitante
      </Button>
      <Button
        variant="outlined"
        color="error"
        startIcon={<DeleteOutlineIcon />}
        sx={{ fontWeight: 700, fontSize: 16, borderRadius: 2, px: 3, py: 1, textTransform: 'none', bgcolor: '#FFF0F0', borderColor: '#F3D1D1', '&:hover': { bgcolor: '#FFE5E5', borderColor: '#F3D1D1' } }}
        onClick={() => onDelete(visitor)}
      >
        Excluir Visitante
      </Button>
    </Box>
  );
} 